import { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Col, Tab, Tabs } from 'react-bootstrap';

//components
import withLocalization from '../../../hoc/withLocalization.js';
import applicationRouter from '~/hoc/applicationRouter'

//elements
import LoadingSpinner from '~/elements/LoadingSpinner';
import Button from '../../../components/CustomButton/CustomButton.jsx';

//utils
import { timeFormat, totalTimeFormat } from '~/utils/dateFormat.js';
import { getCompanyOvertimeTypes } from '~/utils/commonMethods';

const tabs = [
    {
        id: 'schedule',
        title: 'Schedule',
        filter: 'schedule',
    },
    {
        id: 'urgentCall',
        title: 'Urgent',
        filter: 'urgent_call',
    }
];

const PAGE_SIZE = 6;

class AdminPMScheduleWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shifts: [],
            shiftCount: 0,
            urgentCalls: [],
            urgentCallCount: 0,
            moreShifts: false,
            isLoading: true
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const { dashboardStore, commonStore, userStore } = this.props;
        try {
            let pmMembers = '';
            const { currentUser } = userStore;
            if (currentUser.user_type === 'pm' && currentUser?.Manages?.length) {
                pmMembers = currentUser.Manages.join(',');
            }
            const { shifts, shiftCount, urgentCalls, urgentCallCount } = await dashboardStore.getSchedules({
                page: 0,
                pagesize: PAGE_SIZE,
                pmMembers
            })
            const dateTimeRules = commonStore.getDateTimeRules();
            const overtimeTypes = getCompanyOvertimeTypes(commonStore.config.client, commonStore.config.overtimes, false);
            const transformdUrgentCalls = urgentCalls.map(item => ({
                id: item.user_id,
                name: `${item.User.first_name} ${item.User.last_name}`,
                call_type: item.is_field_operative ? "Field Operative" : "Customer Care",
                hours: item.is_field_operative ? totalTimeFormat(item.hours, dateTimeRules) : '-',
                overtime: item.data.timesheet_configs.map(cfg => ({
                    starttime: timeFormat(cfg.from, dateTimeRules),
                    endtime: timeFormat(cfg.to, dateTimeRules),
                    name: overtimeTypes[cfg.overtime_code]?.name
                }))
            }));
            this.setState({
                urgentCalls: transformdUrgentCalls,
                shifts, shiftCount,
                urgentCallCount,
                isLoading: false, moreShifts: shiftCount > PAGE_SIZE
            });
        } catch (error) {
            console.error({ error });
            commonStore.addNotification(error.message || "Something went wrong", null, 'error');
            this.setState({ isLoading: false });
        }

    }

    handleSeeMore = () => {
        const { dashboardStore, commonStore, t } = this.props;
        const { shifts, moreShifts } = this.state;
        let pageLength = Math.floor(shifts.length / PAGE_SIZE);
        dashboardStore.getSchedules({ page: pageLength, pagesize: PAGE_SIZE }).then(resp => {
            if (!resp || !resp.shifts || !resp.shifts.length) {
                return commonStore.addNotification(t('All schedules are fetched'), null, 'success');
            }
            shifts.push(...resp.shifts);
            let _moreShifts = moreShifts;
            if (shifts.length === resp.shiftCount) {
                commonStore.addNotification(t('All schedules are fetched'), null, 'success');
                _moreShifts = false;
            }
            this.setState({ shifts, shiftCount: resp.shiftCount, moreShifts: _moreShifts, isLoading: false });
        });
    };

    handleSeeLess = () => {
        const { shifts, shiftCount } = this.state;
        const _shifts = shifts.slice(0, PAGE_SIZE);
        this.setState({ shifts: _shifts, moreShifts: _shifts.length < shiftCount, isLoading: false });
    };

    getShiftStatus = (work_log_status) => {
        const { t } = this.props;
        switch (work_log_status) {
            case 'NO SHOW':
                return (
                    <td >
                        <span style={{ background: "rgba(239, 188, 188, 0.8)", color: "#FF0000", borderRadius: "10px", padding: "8px" }}>
                            {t(work_log_status)}
                        </span>
                    </td>
                )
            case 'CONFLICT':
            case 'LATE':
                return (
                    <td style={{ color: "blue" }}>
                        <span style={{ background: "#EFF1E4", color: "#2550AC", borderRadius: "13px", padding: "8px" }}>
                            {t(work_log_status)}
                        </span>
                    </td>
                )
            case 'ON TIME':
                return (
                    <td >
                        <span style={{ background: "#C3E7C3", color: "#008000", borderRadius: "13px", padding: "8px" }}>
                            {t(work_log_status)}
                        </span>
                    </td>
                )
            default:
                return (
                    <td style={{ color: "blue" }}>
                        <span style={{ background: "#EFF1E4", color: "#2550AC", borderRadius: "13px", padding: "8px" }}>
                            {t(work_log_status)}
                        </span>
                    </td>
                )
        }

    };

    renderScheduleData = () => {
        const { t, commonStore } = this.props;
        const { moreShifts, shiftCount, shifts } = this.state;
        const dateTimeRules = commonStore.getDateTimeRules();
        if (!shiftCount) {
            return (
                <div className='fw-600 text-start ms-2' style={{ color: "#B2B7B2" }}>
                    {t('No schedule')} {t('Today')}
                </div>
            )
        }

        return (
            <div>
                <table className="table mt-2 projectMemberForm" >
                    <thead>
                        <tr>
                            <th className='text-start'>{t('Name')}</th>
                            <th>{t('Project')}</th>
                            <th>{t('Task')}</th>
                            <th>{t('Scheduled time')}</th>
                            <th>{t('status')}</th>
                        </tr>
                    </thead>
                    <tbody className='dashboard-schedule-table-body' >
                        {shifts.map((shift) => (
                            <tr
                                className="table-project-small__row"
                                key={shift.assignee_id}
                            >
                                <td className='text-start'>{shift.assignee_first_name + ' ' + shift.assignee_last_name}</td>
                                <td>{shift.project_name}</td>
                                <td>{shift.task_name}</td>
                                <td>
                                    {timeFormat(shift.start_time, dateTimeRules)} -{' '}
                                    {timeFormat(shift.end_time, dateTimeRules)}
                                </td>
                                {this.getShiftStatus(shift.work_log_status)}
                            </tr>
                        ))}
                    </tbody>
                </table>
                {!!shiftCount &&
                    <div className='d-flex justify-content-between'>
                        <Button className="mx-1 mx-md-0" disabled={(shifts.length <= PAGE_SIZE) ? true : false} onClick={this.handleSeeLess}>{t('See Less')}</Button>
                        <Button className="mx-1 mx-md-0" disabled={!moreShifts || shifts.length === shiftCount} onClick={this.handleSeeMore}>{t('See More')}</Button>
                    </div>
                }
            </div>
        )
    };

    renderUrgentCallData = () => {
        const { t, commonStore } = this.props;
        const { urgentCalls, urgentCallCount } = this.state;
        const isUrgentCallSettingAvailable = commonStore.checkIfClientHasUrgentCallSettings(null, false, false);

        if (!isUrgentCallSettingAvailable) {
            return (
                <div className='fw-600 text-start ms-2 font-color-primary'>
                    {t("Please configure urgent work settings, contact administrator")}
                </div>
            )
        }

        if (!urgentCallCount) {
            return (
                <div className='fw-600 text-start ms-2' style={{ color: "#B2B7B2" }}>
                    {t('No urgent work planned')}
                </div>
            )
        }

        return (
            <div >
                <table className="table projectMemberForm mt-2" >
                    <thead>
                        <tr>
                            <th className='text-start'>{t('Name')}</th>
                            <th >{t('Urgent work')} {t('Type')}</th>
                            <th >{t('Hours')}</th>
                            <th className='text-start'>{t('Overtime Configuration')}</th>
                        </tr>
                    </thead>
                    <tbody className='dashboard-schedule-table-body' >
                        {urgentCalls.map((call) => (
                            <tr
                                className="table-project-small__row"
                                key={call.id}
                            >
                                <td className='text-start'>{call.name}</td>
                                <td>{t(call.call_type)}</td>
                                <td>{call.hours}</td>
                                <td>
                                    {call.overtime && call.overtime.length > 0 ? (
                                        <div className='text-start'>
                                            {call.overtime.map((ot, index) => (
                                                <div key={index}>
                                                    {ot.name}: {ot.starttime} - {ot.endtime}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <span>-</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    };

    getTitle(tab) {
        const { t } = this.props;
        const { shiftCount, urgentCallCount } = this.state;
        const count = tab.id === 'schedule' ? shiftCount : urgentCallCount;
        return `${t(tab.title)} (${count})`;
    }

    render() {
        const { isLoading } = this.state;
        if (isLoading) return <LoadingSpinner />
        const { t } = this.props;
        return (
            <Fragment>
                <Col sm={12} lg={12}>
                    <h4 className="card-title">
                        <NavLink to="/admin/schedule" className="dashboard-nav-link mx-2 mx-md-none">{t('Schedule')}</NavLink>
                    </h4>
                    <div className="dashboard-tabs-container mt-2">
                        <Tabs defaultActiveKey={tabs[0].id} id="schedule-tabs">
                            {tabs.map(tab => (
                                <Tab eventKey={tab.id} title={this.getTitle(tab)} key={tab.id}>
                                    {tab.id === 'schedule' ? this.renderScheduleData() : this.renderUrgentCallData()}
                                </Tab>
                            ))}
                        </Tabs>
                    </div>
                </Col>
            </Fragment>
        );
    }
}

export default inject('dashboardStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(AdminPMScheduleWidget))));

